import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.SubmitStep.Summary', {
    title: 'Summary',
    companyName: 'Company name',
    destCountries: 'Transaction destination countries',
    currenciesPayOut: 'Currencies you will pay out',
    currenciesSendIn: 'Currencies you will send in',
    directors: 'Directors',
    owners: 'Owners',
    needToWait: 'You will need to wait for user data verification to submit your application',
});
